let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("grOb5")).then(() => parcelRequire('iZ1Mg'));